import ProductCard from "@/components/ProductCard";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import HardLink from "@/components/HardLink";
import { products } from "@/data/products";

const bestsellers = products.slice(0, 4);

const BestsellersSection = () => {
  return (
    <section className="section-darker relative">
      {/* Background Glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-glow-gradient opacity-20 blur-3xl" />

      <div className="container mx-auto px-4 relative z-10">
        {/* Header */}
        <div className="flex flex-col md:flex-row items-center justify-between gap-4 mb-8">
          <div>
            <h2 className="text-3xl md:text-4xl font-display font-bold text-foreground">
              <span className="text-gradient-green">Bestsellers</span>
            </h2>
            <p className="text-muted-foreground mt-2">
              Onze meest populaire auto en motor detailing producten, geliefd door duizenden voertuigliefhebbers
            </p>
          </div>
          <Button variant="outline" size="lg" asChild>
            <HardLink to="/shop">
              Bekijk Alles
              <ArrowRight className="w-4 h-4 ml-2" />
            </HardLink>
          </Button>
        </div>

        {/* Products Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {bestsellers.map((product) => (
            <ProductCard 
              key={product.id} 
              {...product} 
              productId={product.id} 
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default BestsellersSection;
